import React from 'react';
import { Redirect } from 'react-router';
import Card from './Card';
import { journaliserErreur, journaliserException } from '../App_Code/API';

function obtenirCheminParent(location) {
    const cheminComplet = location.pathname;
    const indice = cheminComplet.lastIndexOf('/');
    return cheminComplet.slice(0, indice);
}

function objetExiste(objet) {
    return objet !== undefined && objet !== null;
}

const AlerteDev = ({ titleName }) => (
    <Card Titre={titleName} className="alert-danger">
        <div className="card-text text-center">
            <p>
                <i className="fas fa-5x fa-exclamation-triangle mt-3" />
            </p>
            <p>Ce composant présente une erreur.</p>
        </div>
    </Card>
);

const AlerteProd = ({ titleName }) => (
    <Card Titre={titleName}>
        <div className="card-text">
            <p>
                <i>Une erreur est survenue lors du chargement.</i>
            </p>
        </div>
    </Card>
);

const Alerte = props => (process.env.NODE_ENV === 'development' ? <AlerteDev {...props} /> : <AlerteProd {...props} />);

export const verificationProps = WrappedComponent => (childProps) => {
    let valide = true;
    let invisible = false;
    const invalide = [];
    const cles = Object.keys(childProps);

    WrappedComponent.requiredProps.forEach((prop) => {
        const ok = cles.includes(prop) && objetExiste(childProps[prop]);
        if (!ok) invalide.push(prop);
        if (childProps[prop] === 'PAS_DE_CONTENU') invisible = true;
        valide = valide && ok;
    });

    if (invisible) return null;

    const composant = valide ? <WrappedComponent {...childProps} /> : <Alerte {...WrappedComponent} />;
    if (!valide) {
        const chemin = window.location.pathname.split('/');
        const EE = {
            Page: chemin[chemin.length - 1],
            Methode: WrappedComponent.displayName,
            Message: `Les propriétés suivantes sont nécessaires mais absentes : ${invalide}`,
            Source: window.location.href,
        };
        journaliserErreur(EE);
    }

    return composant;
};

export const verificationLocationState = WrappedComponent => (childProps) => {
    if (childProps && childProps.location && childProps.location.hash) {
        return <WrappedComponent {...childProps} />;
    }

    if (!childProps || !childProps.location || !childProps.location.state) {
        return <Redirect to={obtenirCheminParent(childProps.location)} />;
    }

    const cles = Object.keys(childProps.location.state);
    const valide = WrappedComponent.requiredLocationState.every(prop => cles.includes(prop) && objetExiste(childProps.location.state[prop]));
    return valide ? <WrappedComponent {...childProps} /> : <Redirect to={obtenirCheminParent(childProps.location)} />;
};

export const mapStateToPropsWrapper = fnc => (store) => {
    try {
        return fnc(store);
    } catch (ex) {
        const chemin = window.location.pathname.split('/');
        const EE = {
            Page: chemin[chemin.length - 1],
            Methode: 'mapStateToProps',
            Message: ex.message,
            Source: window.location.href,
            PileErreur: ex.stack,
        };
        journaliserException(EE);
        return {};
    }
};



// WEBPACK FOOTER //
// ./src/components/CaptureErreurs.js